import { CoreOptions } from '@segment/analytics-core';

import { useAnalyticsContext } from '@percent/hosted-validation-form/context/analytics/AnalyticsContext/useAnalyticsContext';

export const useAnalytics = () => {
  const { analytics } = useAnalyticsContext();

  if (!analytics) return null;

  const page = async (
    category: string,
    name: string,
    properties?: Record<string, unknown>,
    options?: { context: CoreOptions },
  ) => analytics?.page(category, name, properties, options);

  const identify = async (
    userId?: string,
    traits?: Record<string, unknown>,
    options?: { anonymousId?: string; context?: CoreOptions },
  ) => analytics?.identify(userId, traits, options);

  const track = async (name: string, properties: Record<string, unknown>, options?: { context?: CoreOptions }) =>
    analytics?.track(name, properties, options);

  return {
    page,
    identify,
    track,
  };
};
